"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthProvider = void 0;
const react_query_1 = require("react-query");
const axios_1 = require("axios");
const Utils_1 = require("../utils/Utils");
exports.AuthProvider = () => react_query_1.useMutation((data) => {
    return axios_1.default.post(`${Utils_1.APIURL}/api/users/login`, data);
});
//# sourceMappingURL=AuthProvider.js.map